import * as types from "./actionType";

const initialState = {
  vinLookupStatus: false,
  vinLookup: [],
  ownershipTransferStatus: false,
  ownershipTransfer: null,
  allUserStatus: true,
  allUser: [],
  transferModerationListingStatus: true,
  transferModerationListing: [],
  transferModerationDetailListingStatus: true,
  transferModerationDetailListing: [],
  transferModerationCount: 0,
  transferModerationStatus: true,
  transferModeration: [],
  documentUpload: null,
  documentUploadStatus: false,
  documentRead: [],
  documentReadStatus: false,
  binaryDocument: null,
};

function vinLookupReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_VIN_LOOKUP:
      return {
        ...state,
        vinLookupStatus: true,
        vinLookup: [],
      };
    case types.FETCH_VIN_LOOKUP_SUCCESS: {
      return {
        ...state,
        vinLookupStatus: false,
        vinLookup: action.payload,
      };
    }
    case types.FETCH_VIN_LOOKUP_FAILED: {
      return {
        ...state,
        vinLookupStatus: false,
        vinLookup: [],
      };
    }

    case types.CHANGE_OWNERSHIP_TRANSFER:
      return {
        ...state,
        ownershipTransferStatus: true,
        ownershipTransfer: null,
      };
    case types.CHANGE_OWNERSHIP_TRANSFER_SUCCESS: {
      return {
        ...state,
        ownershipTransferStatus: false,
        ownershipTransfer: action.payload,
      };
    }
    case types.CHANGE_OWNERSHIP_TRANSFER_FAILED: {
      return {
        ...state,
        ownershipTransferStatus: false,
        ownershipTransfer: null,
      };
    }

    case types.FETCH_ALL_USERS:
      return {
        ...state,
        allUserStatus: true,
        allUser: [],
      };
    case types.FETCH_ALL_USERS_SUCCESS: {
      return {
        ...state,
        allUserStatus: false,
        allUser: action.payload,
      };
    }
    case types.FETCH_ALL_USERS_FAILED: {
      return {
        ...state,
        allUserStatus: false,
        allUser: [],
      };
    }

    case types.FETCH_TRANSFER_MODERATION_LISTING:
      return {
        ...state,
        transferModerationListingStatus: true,
        transferModerationListing: [],
      };
    case types.FETCH_TRANSFER_MODERATION_LISTING_SUCCESS: {
      return {
        ...state,
        transferModerationListingStatus: false,
        transferModerationListing: action.payload.data,
        transferModerationCount: action.payload.count,
      };
    }
    case types.FETCH_TRANSFER_MODERATION_LISTING_FAILED: {
      return {
        ...state,
        transferModerationListingStatus: false,
        transferModerationListing: [],
      };
    }

    case types.FETCH_TRANSFER_MODERATION_DETAIL_LISTING:
      return {
        ...state,
        transferModerationDetailListingStatus: true,
        transferModerationDetailListing: [],
      };
    case types.FETCH_TRANSFER_MODERATION_DETAIL_LISTING_SUCCESS: {
      return {
        ...state,
        transferModerationDetailListingStatus: false,
        transferModerationDetailListing: action.payload.data,
      };
    }
    case types.FETCH_TRANSFER_MODERATION_DETAIL_LISTING_FAILED: {
      return {
        ...state,
        transferModerationDetailListingStatus: false,
        transferModerationDetailListing: [],
      };
    }

    case types.TRANSFER_MODERATION:
      return {
        ...state,
        transferModerationStatus: true,
        transferModeration: [],
      };
    case types.TRANSFER_MODERATION_SUCCESS: {
      return {
        ...state,
        transferModerationStatus: false,
        transferModeration: action.payload,
      };
    }
    case types.TRANSFER_MODERATION_FAILED: {
      return {
        ...state,
        transferModerationStatus: false,
        transferModeration: [],
      };
    }

    case types.UPLOAD_URL:
      return {
        ...state,
        documentUploadStatus: true,
        documentUpload: null,
      };
    case types.UPLOAD_URL_SUCCESS: {
      return {
        ...state,
        documentUploadStatus: false,
        documentUpload: action.payload,
      };
    }
    case types.UPLOAD_URL_FAILED: {
      return {
        ...state,
        documentUploadStatus: false,
        documentUpload: null,
      };
    }

    case types.READ_URL:
      return {
        ...state,
        documentReadStatus: true,
      };
    case types.READ_URL_SUCCESS: {
      return {
        ...state,
        documentReadStatus: false,
        documentRead: action.payload,
      };
    }
    case types.READ_URL_FAILED: {
      return {
        ...state,
        documentReadStatus: false,
        documentRead: [],
      };
    }

    case types.UPLOAD_BINARY_URL:
      return {
        ...state,
        binaryDocument: null,
      };
    case types.UPLOAD_BINARY_URL_SUCCESS: {
      return {
        ...state,
        binaryDocument: action.payload,
      };
    }
    case types.UPLOAD_BINARY_URL_FAILED: {
      return {
        ...state,
        binaryDocument: null,
      };
    }

    case types.CLEAR_REDUCER_VIN_LOOKUP:
      return {
        ...state,
        allUserStatus: true,
        transferModerationCount: 0,
        documentUpload: null,
        documentRead: [],
        binaryDocument: null,
      };

    default:
      return state;
  }
}

export default vinLookupReducer;
